import ApplyForCasinoCredit from './ApplyForCasinoCredit';

export default ApplyForCasinoCredit;
